export default __webpack_public_path__ + "static/media/eggs.b9a80af6.png";